import request from '@/utils/request'


// 产品列表
export const productList = ()=>{
  return request({
    url: '/admin-api/client/pc/product/get/simple-list',
    method: 'get',
  })
}

// 设备列表
export const deviceList = (params) => {
  return request({
    url: '/admin-api/client/pc/device/page',
    method: 'get',
    params: params
  })
}

// 设备详情
export const deviceDetail = (params) => {
  return request({
    url: '/admin-api/client/pc/device/deviceName/get',
    method: 'get',
    params: params
  })
}


// 获得组下设备列表
export const groupDeviceList = (params) => {
  return request({
    url: '/admin-api/client/pc/device/get-group-device-list',
    method: 'get',
    params: params
  })
}



// 获取设备最新数据
export const latestData = (params)=>{
  return request({
    url: '/admin-api/client/pc/device/get/latest-data',
    method: 'get',
    params: params
  })
}


// 获取设备最新数据 - 新接口
export const getDeviceLastData = (deviceName)=>{
  return request({
    url: `/admin-api/device/data/all/data-last?deviceName=` + deviceName,
    method: 'get'
  })
}


// 修改设备
export const updateDevice = (data) => {
  return request({
    url: '/admin-api/client/pc/device/update',
    method: 'put',
    data: data
  })
}


// 根据属性标识获得产品属性配置MAP
export const signData = (list)=>{
  return request({
    url: `/admin-api/client/pc/element/get-map/yeu-sign?yeuSigns=${list}`,
    method: 'get',
  })
}

// 获取设备区间数据数据-MAP格式
export const signTimeDataMap = (params)=>{
  return request({
    url: `/admin-api/client/pc/device/get/format-map/time-interval-data`,
    method: 'get',
    params: params
  })
}

// 获取设备区间数据数据-属性标识数组格式
export const signTimeData = (params)=>{
  return request({
    url: `/admin-api/client/pc/device/get/format-sign-array/time-interval-data`,
    method: 'get',
    params: params
  })
}

// 导出设备数据 Excel
export const exportDeviceData = (params)=>{
  return request({
    url: `/admin-api/client/pc/device/export-device-data-excel`,
    method: 'get',
    params: params,
    responseType: 'blob'  // 指定响应类型为 blob
  })
}


// 获得设备物模型
export const deviceTsl = (params) => {
  return request({
    url: '/admin-api/client/pc/device/get/tsl',
    method: 'get',
    params: params
  })
}
